
import { Component, Vue, Prop } from 'vue-property-decorator';
import CardSpedizione from './CardSpedizione.vue';
import { Spedizione } from '@/models';

@Component({
  components: { 
      CardSpedizione
    }
})
export default class SpedizioniCards extends Vue {
    @Prop() private spedizioni!: Spedizione[];
    @Prop({ default: false }) private compact!: boolean;
}
